export default __webpack_public_path__ + "static/gallery-award-actso-b66af92113ba660a811abf9247e4c476.jpg";